import Breakpoints from './Breakpoints';
import Flickity from './Flickity';
import 'flickity-fade';

const config = {
  mobileSettings: {
    fade: false,
    autoPlay: false,
    wrapAround: true,
    prevNextButtons: false,
  },
  desktopSettings: {
    fade: true,
    autoPlay: 4000,
    wrapAround: false,
    prevNextButtons: false,
  },
};

export default class HomeSpotlights {
  constructor(element) {
    this.element = element;

    // Exit if the sliderElement isn't found.
    if (!this.sliderElement) return;

    // Prevent initialization of a slider with less than 2 slides.
    if (this.shouldBuildSlider) {
      // Add listeners
      this.listen();
    }

    // Ready Component
    this.ready();
  }

  ready() {
    this.element.classList.add('ready');
  }

  onChange() {
    if (this.slider.player.state === 'stopped') {
      this.setPauseState();
    }
  }

  turnOnSliderListeners() {
    // Turn on tracking of current state of gallery
    this.slider.on('change', this.onChange.bind(this));
  }

  turnOffSliderListeners() {
    // Turn off tracking of current state of gallery
    this.slider.off('change', this.onChange.bind(this));
  }

  addControls() {
    const item = document.createElement('li');
    this.playPauseButton = document.createElement('button');
    this.playPauseButton.className = 'button--play-pause';
    this.playPauseButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><polygon class="play" points="0 0 0 13 13 6.36 0 0"/><g class="pause"><path d="M11.15,0H8.85A.88.88,0,0,0,8,.91V12.13a.86.86,0,0,0,.85.87h2.31a.86.86,0,0,0,.84-.88V.91A.88.88,0,0,0,11.15,0Z"/><path d="M4.15,0H1.85A.88.88,0,0,0,1,.91V12.13a.86.86,0,0,0,.85.87H4.16A.86.86,0,0,0,5,12.12V.91A.88.88,0,0,0,4.15,0Z"/></g></svg>';
    this.playPauseButton.addEventListener('click', this.playPauseHandler.bind(this));
    item.appendChild(this.playPauseButton);
    this.sliderDots.appendChild(item);
  }

  playPauseHandler() {
    if (this.slider.player.state === 'stopped') {
      this.slider.playPlayer();
      this.setPlayState();
    } else {
      this.slider.stopPlayer();
      this.setPauseState();
    }
  }

  setPlayState() {
    this.playPauseButton.setAttribute('aria-label', 'Stop the slider\'s autoscroll');
    this.sliderElement.classList.add('playing');
  }

  setPauseState() {
    this.playPauseButton.setAttribute('aria-label', 'Start the slider\'s autoscroll');
    this.sliderElement.classList.remove('playing');
  }

  build(settings) {
    // Fire up a new flickity slider instance
    this.slider = new Flickity(this.sliderElement, settings);

    // If autoplay is enabled, add play/pause support.
    if (settings.autoPlay) {
      // Add play/pause controls
      this.addControls();

      // Set initial state of the gallery
      this.setPlayState();

      // Add listeners
      this.turnOnSliderListeners();
    }
  }

  restore() {
    return new Promise((resolve) => {
      if (this.slider) {
        this.turnOffSliderListeners();
        this.slider.destroy();
        this.slider = null;
      }
      resolve();
    });
  }

  mobileHandler() {
    this.restore().then(this.build(config.mobileSettings));
  }

  desktopHandler() {
    this.restore().then(this.build(config.desktopSettings));
  }

  listen() {
    // Listen for breakpoint changes
    Breakpoints.on('mobile tablet', 'enter', this.mobileHandler.bind(this));
    Breakpoints.on('desktop larger', 'enter', this.desktopHandler.bind(this));
  }

  get shouldBuildSlider() {
    return this.slides.length > 1;
  }

  get sliderElement() {
    return this.element.querySelector('.block-content');
  }

  get sliderDots() {
    return this.sliderElement.querySelector('.flickity-page-dots');
  }

  get slides() {
    return this.sliderElement.children;
  }
}
